'use client';

import { Layout, Flex } from 'antd';
//import { SwitchTheme } from '@/features/switch-theme';

import styles from './styles.module.scss';
import { SwitchTheme } from '@/features/switch-theme';
import { ChangeLang } from '@/features/change-lang';

export default function AuthPageHeader() {
  return (
    <Layout.Header className={styles.header} data-have-back={false}>
      <Flex gap={12} align='center'>
        <></>
        {/* Agregá ChangeLang si lo migrás */}
        <SwitchTheme />
        <ChangeLang />
      </Flex>
    </Layout.Header>
  );
}
/*  <SwitchTheme />*/
